
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"18","height":"9","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M2.978 4.365c-.263-.263-.716-.224-.76.145-.041.344.062.69.313.941.25.251.597.355.94.314.37-.044.409-.497.146-.76l-.64-.64zM11.832 4.51c.045-.369.498-.408.76-.145l.64.64c.263.263.224.716-.145.76-.344.04-.69-.063-.941-.314a1.129 1.129 0 01-.314-.94z","fill":"#EE4F23"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M8.15 4.669c-.249 2.05-1.972 3.639-4.059 3.639C1.831 8.308 0 6.448 0 4.154 0 1.86 1.832 0 4.091 0 5.96 0 7.537 1.273 8.025 3.012a2.08 2.08 0 011.95 0C10.463 1.271 12.04 0 13.909 0 16.169 0 18 1.86 18 4.154c0 2.294-1.832 4.154-4.091 4.154-2.088 0-3.81-1.588-4.06-3.64-.11-.079-.21-.175-.306-.27a.919.919 0 00-.187-.142A.728.728 0 009 4.154a.8.8 0 00-.543.245c-.095.094-.197.19-.306.27zM4.092 6.923c1.475 0 2.706-1.22 2.706-2.77 0-1.549-1.231-2.768-2.706-2.768-1.475 0-2.706 1.22-2.706 2.769 0 1.55 1.231 2.77 2.706 2.77zm9.818 0c1.475 0 2.706-1.22 2.706-2.77 0-1.549-1.231-2.768-2.706-2.768-1.475 0-2.706 1.22-2.706 2.769 0 1.55 1.231 2.77 2.706 2.77z","fill":"#EE4F23"}})])
          )
        }
      }
    